export const SPECTRUM_BREADTH = 12;